import ScheduleIndexVue from "@/views/housekeeping/schedule/ScheduleIndex.vue";

const schedule = [
    {
        path: '/schedule',
        name: 'schedule',
        component: ScheduleIndexVue
    }
]

export default schedule;